import TourService from '../services/tour/Service'
import { getStore } from '@/store/StoreInstance';

export default IS_WEB_COMPONENT ? {} : {
	data() {
		return {
      tour: null,
		};
	},
	mounted() {},
	watch: {
		workflowsLoaded(newVal) {
			if (newVal) this.startTour('workflow')
		},
		elnTour() {
			this.setUpElnTour();
		},
	},
	computed: {
		isTourActive() {
			return this?.tour?.isActive()
		}
	},
	methods: {
		startTour(tourName, isManualTour, options) {
			TourService.getTourStatus();
			if(isManualTour && this.tourViewed(tourName) || !this.tourViewed(tourName)) {
				this.setIsTabletView();
				this.initTour(tourName, options);
				this.setTourStorage(tourName)
			}
		},
		setUpElnTour(isManualTour) {
			TourService.getTourStatus();
			let options = {}
			if(isManualTour || !this.tourViewed('eln')) {
				let firstLabNotesArea;
				let firstAccordion;
				let firstQsp;
				this.$nextTick(() => {
					// if the eln view is active, then add the first lab-note to the eln tour
					firstLabNotesArea = document.querySelector(".tour-target");
					$(firstLabNotesArea).attr('id', 'eln-tour-step1');

					// if there are qsps, then add the first qsp to the eln tour
					firstAccordion = document.querySelector(".accordion-opener");
					if(firstAccordion) {
						$(firstAccordion).attr('id', 'eln-first-accordion');
						if (!firstAccordion.nextElementSibling)
							$(firstAccordion).click();
						this.$nextTick(() => {
							firstQsp = document.querySelector(".quick-start-protocol");
							$(firstQsp).attr('id', 'eln-tour-step2');
						})
					} else  {
						options.elnHideLastStep = true
					}
				});
				if(isManualTour) {
					this.startTour('eln', true, options);
				} else {
					this.startTour('eln',false, options);
				}
			}
		},
		setIsTabletView() {
			let browserWidth = window.innerWidth;
			let isTabletView = browserWidth > 600 && browserWidth <= 1080;
			this.$store.dispatch('tour/setIsTabletView', isTabletView);
		},
		getIsMobileView() {
			return window.innerWidth <= 600;
		},
		setNextStep() {
			const labels = document.querySelectorAll('.dropdown_label')
			let labelsHaveText = Array.from(labels).every(label => label.innerText.length >= 1)
			if (!this.tour) return
			if (this.tour.currentStep.id === 'finder-step5' && labelsHaveText) {
				this.tour.show('finder-step5')
			} else {
				this.tour.next();
			}
		},
		tourViewed(tourName) {
			return this.$store.getters['tour/getTour'](tourName)
		},
		setTourStorage(tourName){
			localStorage.setItem(`tour-${tourName}`, JSON.stringify(true));
		},
		resetTourStorage() {
			const tour = ['product', 'finder', 'workflow', 'eln']
			const resetTour = tour.map(type => ({[type]: false}))
			for (const obj of resetTour)
				getStore().dispatch('tour/setTour', obj)
			tour.forEach((tourName) => {
				localStorage.setItem(`tour-${tourName}`, JSON.stringify(false));
			})
			if(this.labNotesActive && window.innerWidth > 600) {
				this.setUpElnTour(true);
			} else {
				this.startTour('workflow', true);
			}
		},
		getContainer (tourName) {
			switch (tourName) {
				case 'product':
					return document.querySelector('#options-modal-wrapper .options-modal')
				case 'finder':
					return document.querySelector('#tour-finder')
				case 'workflow':
					return this.$el
				default:
					return this.$el
			}
		},
		tourOptions(tourName) {
			return {
				classPrefix: `${tourName}-tour-`,
				defaultStepOptions: {
					classes: 'tour-modal'
				},
				tourName,
				modalContainer: this.getContainer(tourName),
				stepsContainer: this.getContainer(tourName),
				useModalOverlay: tourName !== 'finder',
				mobile: this.getIsMobileView(),
				hasProductGroups: this.hasProductGroups,
				scrollTo: {
					behavior: 'smooth',
					block: 'center'
				},
				scrollTo: true,
				keyboardNavigation: false,
				vInstance: this
			}
		},
		workflowMobileScroll(steps) {
			let beforeShowPromise = {
				beforeShowPromise: async function() {
					return await new Promise((resolve) => {
						setTimeout(() => {
							return resolve()
						}, 100)
					})
				}
			}
			return steps.map(step => {
				return {...step, ...beforeShowPromise}
			})
		},
		setMobileChanges(steps, tourName) {
			if (tourName === 'finder') {
				// change placement of popup
				steps.forEach(step => step.attachTo.on = 'top-start');
			}
			if (tourName === 'workflow') {
				// removes last step; not to be shown in mobile
				steps = this.workflowMobileScroll(steps)
				steps.pop();
			}
			if (tourName === 'product') {
				steps.forEach(step => step.attachTo.on = 'bottom-end');
				if (!this.hasProductGroups ) {
					steps = steps.filter(item => !['product-tour-step-2', 'product-tour-step-3'].includes(item.id))
				}
			}
			return steps
		},
		setDesktopChanges(steps, tourName, options) {
			if (tourName === 'product') {
				if (this.hasProductGroups ) {
					steps = steps.filter(item => !['product-tour-step-2'].includes(item.id))
				} else {
					steps = steps.filter(item => !['product-tour-step-2', 'product-tour-step-3'].includes(item.id))
				}
			}
			if (tourName ==='eln' && options.elnHideLastStep) {

				steps.pop();
				if (steps.length == 1) {
					steps[0].recreateButtons(this.tour, ['finish','cancel'])
				}
			}
			return steps
		},
		addFinderBtnListeners() {
			let btns = document.querySelectorAll('#tour-finder .home .categories .custom-dropdown')
				btns.forEach(btn => {
					if(btn.id === 'finder-tour-step1') {
						btn.addEventListener('click', () => {
							if (this.tour.isActive()){
								this.tour.hide();
							}
						});
					}
				})
			},

		setStep(id){
			const getStepNum = id.split('-').pop()
			if (getStepNum === 'step1') {
				let step = this.tour.getById(`finder-${getStepNum}`)
				step.options.attachTo.on = 'top-start'
			}
			if (this.tour.currentStep.id !== `finder-${getStepNum}`) {
				this.tour.show(`finder-${getStepNum}`)
			}
		},
		addObserverToDropdown() {
			// targets element that we will observe
			const targets = document.querySelectorAll('.custom-dropdown');
			// config object
			const config = {
				childList: true,
			};
			// subscriber function
			function subscriber(mutations) {
				for(const mutation of mutations) {
					if (mutation.type === 'childList') {
						if (mutation.addedNodes.length <= 0 || mutation.addedNodes.nodeName === "#comment") return
						let id =	Array.from(mutation.addedNodes).map(function (addedNode) {
							if (!addedNode.classList) return
							if (addedNode.classList.contains('dropdown_list-wrap')) {
								return mutation.target.id
							}
						});

						const labels = document.querySelectorAll('.dropdown_label')
						let labelsHaveText = Array.from(labels).every(label => label.innerText.length >= 1)

						if(labelsHaveText) {
							this.tour.show('finder-step5')
						}
						if (id[0]) {
							this.setStep(id[0])
						}
					}
				}
			}

			// instantiating observer
			const observer = new MutationObserver(subscriber.bind(this));
			targets.forEach(target => {
				// observing targets
				observer.observe(target, config);
			})
			// This stops the MutationObserver
  		// observer.disconnect();
		},
		restyleModal() {
			let header = document.querySelector('#options-modal-wrapper .wrapper-header')
			header.classList.toggle('tour-zindex')
			const buttonWrapper = header.querySelector('.right-side')
			if (buttonWrapper.classList.contains('button-index')) {
				buttonWrapper.classList.remove('button-index')
			}
		},
		handleTourCancel (tourName) {
			if (tourName === 'product') {
				this.restyleModal()
			}
			if(tourName === 'workflow') {
				document.body.classList.remove('overflow-hidden')
			}
		},
		resetFinderTourFlag(){
			let tourFlag = this.$store.getters['tour/getTourFlag']
			if (tourFlag) {
				this.$store.dispatch('tour/setTourFlag', false);
			}
		},
		initTour(tourName, options = {}) {
			this.$nextTick(() => {
				this.tour = this.$shepherd(this.tourOptions(tourName));
				if(tourName === 'product') {
					this.restyleModal()
				}
				if(tourName === 'workflow' && this.getIsMobileView()) {
					document.body.classList.add('overflow-hidden')
				}
				['complete', 'cancel'].forEach(event => this.tour.on(event, () => this.handleTourCancel(tourName)));
				let tourSteps = TourService.getSteps(this.tour, tourName, this.getIsMobileView());
				if (this.getIsMobileView()) {
					tourSteps = this.setMobileChanges(tourSteps, tourName)
				} else {
					tourSteps = this.setDesktopChanges(tourSteps, tourName, options)
				}
				if(!document.querySelector('#workflow-tags > .workflow-group')){
					tourSteps = tourSteps.filter(step=>step.id!='workflow-tags-step')
				}
				if (tourName === 'finder') {
					this.addFinderBtnListeners()
					this.addObserverToDropdown()
				}
				this.tour.addSteps(tourSteps)
				this.tour.start();
				this.$store.dispatch('tour/setTourFlag', true);
			});
		}
	}
};
